import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_generic_doc_customer_review_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    mkt_comment_id: fromDatatype.VarcharDatatypeInterface;
    comment_content: fromDatatype.TextDatatypeInterface;
    rating_star: fromDatatype.IntegerDatatypeInterface;
    sales_order_guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    ecomsync_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    mkt_order_no: fromDatatype.VarcharDatatypeInterface;
    buyer_username: fromDatatype.VarcharDatatypeInterface;
    mkt_item_id: fromDatatype.VarcharDatatypeInterface;
    submit_time: fromDatatype.TimestampTzDatatypeInterface;
    reply_content: fromDatatype.TextDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    mkt_type: fromDatatype.VarcharDatatypeInterface;
    mkt_guid: fromDatatype.GuidDataFieldInterface;
    mkt_code: fromDatatype.VarcharDatatypeInterface;
    item_name: fromDatatype.VarcharDatatypeInterface;
    replied_by_name: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_generic_doc_customer_review_queue_RowClass
    implements bl_fi_generic_doc_customer_review_queue_RowInterface {
        guid: fromDatatype.GuidDataFieldInterface;
        mkt_comment_id: fromDatatype.VarcharDatatypeInterface;
        comment_content: fromDatatype.TextDatatypeInterface;
        rating_star: fromDatatype.IntegerDatatypeInterface;
        sales_order_guid: fromDatatype.GuidDataFieldInterface;
        entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
        ecomsync_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
        mkt_order_no: fromDatatype.VarcharDatatypeInterface;
        buyer_username: fromDatatype.VarcharDatatypeInterface;
        mkt_item_id: fromDatatype.VarcharDatatypeInterface;
        submit_time: fromDatatype.TimestampTzDatatypeInterface;
        reply_content: fromDatatype.TextDatatypeInterface;
        created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        created_date: fromDatatype.TimestampTzDatatypeInterface;
        updated_date: fromDatatype.TimestampTzDatatypeInterface;
        status: fromDatatype.VarcharDatatypeInterface;
        revision: fromDatatype.GuidDataFieldInterface;
        vrsn: fromDatatype.VarcharDatatypeInterface;
        mkt_type: fromDatatype.VarcharDatatypeInterface;
        mkt_guid: fromDatatype.GuidDataFieldInterface;
        mkt_code: fromDatatype.VarcharDatatypeInterface;
        item_name: fromDatatype.VarcharDatatypeInterface;
        replied_by_name: fromDatatype.VarcharDatatypeInterface;
    }